import { Data, post } from '../networking';

export interface AdjustEventPayload {
    event_token: string;
    adid?: string;
    idfv?: string;
    gps_adid?: string;
}

export const ADJUST_EVENTS = {
    ios: {
        phone: 'my2i6u',
        email: 'gc6ru6',
    },
    android: {
        phone: '2lyidp',
        email: '7v62y0',
    }
};

export function trackAdjustEvent(payload, platform): Promise<Data> {
    return post(`adjust/track-event/${platform}`, payload as Data);
}
